import { render, staticRenderFns } from "./CarPartView.vue?vue&type=template&id=6e2b66b6"
import script from "./CarPartView.vue?vue&type=script&lang=js"
export * from "./CarPartView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports